<template>
  <div class="settings">
    <h1>
      {{ $t("langcfg.txtLanguage") }}
    </h1>
    <div style="margin-top: 30px">
      <div style="margin-top: 20px" v-for="item in languages" :key="item.key">
        <el-radio-group v-model="language" text-color="#00ff00">
          <el-radio
            :label="item.key"
            text-color="#00ff00"
            @change="selectItem"
            style="width: 200px"
          >
            {{ item.label }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
    <br />
    <!-- <div v-if="isKeyboardLoading">
      <span class="el-icon-loading waitting-icon"></span>
      <span class="">{{ $t('langcfg.txtKeyboardReloading') }}...</span>
    </div> -->
  </div>
</template>
<script>
import { saveSettings } from "../../../settings";
import { LANGUAGES } from "../../../shared/consts";
// 111
import EVENTS from "../../../bus";
import { mapState } from "vuex";
import home from "../../../store/modules/home";
const { ipcRenderer } = window.require("electron");
export default {
  name: "Language",
  data() {
    return {
      language: "en_US",
      languages: []
    };
  },
  methods: {
    selectItem(key) {
      this.isLoadingVisible = true;
      this.$i18n.locale = key;
      window.settings.language = key;
      saveSettings(window.settings);
      this.$emit("change-language");
      this.$bus.$emit("CHANGEVIDEOSPEEDBTN");
    },
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setLang, function (msg) {
        _this.isLoadingVisible = true;
        _this.$i18n.locale = msg.key;
        window.settings.language = msg.key;
        _this.language = msg.key;
        saveSettings(window.settings);
      });
    }
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    })
  },
  created() {
    this.languages = LANGUAGES.filter((item) => {
      return item.visible;
    });
    this.language = window.settings.language;
    this.watchSetStatus();
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setLang);
  },
  props: {
    isKeyboardLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped>
.settings {
  margin-top: 60px;
  margin-left: 30px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 300px;
}
.logo-img {
  width: 350px;
}
.el-radio {
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
.el-radio-group /deep/ label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Language.vue